export default "__VITE_ASSET__WJjutjD0__"